export class ResponseValidator {

  status: boolean;
  statusCode: string;
  statusDesc: string;
  header: any = {};
  hasHeaders: boolean;

  constructor(response?: any, statusCodeOnly?: boolean) {
    if (!response) {
      return;
    }
    try {
      this.hasHeaders = (response.response && response.response.header) ||
        (response.getBccContentResponse && response.getBccContentResponse.header);
      this.header = this.hasHeaders ? this.hasHeaders : response.responseMetaData;
      this.statusCode = this.header.statusCode;
      this.header = this.header || {};
      this.statusDesc = (this.header.statusDescription || this.header.statusDesc || '').toLowerCase();
      const isSuccess = ((this.statusCode === '0000' || this.statusCode === '200')
        && (!statusCodeOnly ? this.statusDesc === 'success' : true));
      if (isSuccess) {
        this.status = true;
      } else {
        this.status = false;
      }

    } catch (e) {
      console.log(e);
    }
    // console.log('res', response, this.status, this.header)
  }
  /**
   * Check object for a specific path
   * param obj| Object
   * param depth| string
   *
   * return object|null
   */
  public find(obj: any, depth: string): any|null {
    let clone = obj && typeof obj === 'object' ? JSON.parse(JSON.stringify(obj)) : {};
    const notFound = depth.split('.').some( k => {
      const hasProp = clone.hasOwnProperty(k);
      clone = hasProp ? clone[k] : clone;
      return !hasProp;
    });
    return notFound ? null : clone;
  }
}
